import React, { Suspense, lazy } from 'react';
import { createPortal } from 'react-dom';
import ActionButton from '../input/ActionButton';
import './LocationSelect.css';

// Fallback when the map chunk cannot be loaded (e.g. connection lost before the service worker cached it).
// Without it the failed lazy import would reach the root and blank the whole app.
function MapDialogUnavailable({ open, onClose }) {
  if (!open) return null;
  return createPortal(
    <div className="customPopupOverlay locationSelectFallback" onClick={e => e.stopPropagation()}>
      <div className="customPopupContent" role="alertdialog" aria-modal="true">
        <p>Die Karte konnte nicht geladen werden. Bitte Verbindung prüfen und die Seite neu laden.</p>
        <div className="customPopupActions">
          <ActionButton label="Ok" type={3} onClick={onClose} />
        </div>
      </div>
    </div>,
    document.body
  );
}

// Leaflet is only loaded when the dialog is opened for the first time.
const LocationMapDialog = lazy(() =>
  import('./LocationMapDialog').catch(() => ({ default: MapDialogUnavailable })));

/**
 * Map dialog (create/edit a Location), loaded on demand. Shared by the location select of the event
 * forms ("Neue Location …") and the admin page /locations.
 * Callers render it only after the first open and keep it mounted, so the exit animation can play.
 * Props are passed through to LocationMapDialog (open, mode, initial, fallbackCenter, existingLocations,
 * onClose, onSaved).
 */
function LazyLocationMapDialog(props) {
  return (
    <Suspense fallback={null}>
      <LocationMapDialog {...props} />
    </Suspense>
  );
}

export default LazyLocationMapDialog;
